import styled from "styled-components";
import {InputLabel} from "@mui/material";

export const SelectLabel = styled(InputLabel)`
	&&.MuiInputLabel-root {
		text-align: left;
		color: #a3a3a3;
	}
`;
